import { config } from '@/config';
import { RECAPTCHA_V3_URL } from '@/config/externalScriptsUrl';

const isOnboarding = window.location.pathname.includes('onboarding');

export const generateRecaptchaToken = async (sitekey, action) => {
  let tokenReceived = '';
  await window.grecaptcha.execute(sitekey, { action })
    .then((token) => {
      tokenReceived = token;
    });
  return tokenReceived;
};

export const loadReCaptcha = () => {
  if (isOnboarding) return;

  const hasRecaptchaScript = document.getElementById('recaptcha-script');
  if (!hasRecaptchaScript) {
    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = RECAPTCHA_V3_URL(config.RECAPTCHA_SITE_KEY);
    document.body.appendChild(script);
  }
};

export const loadReCaptchaPaaS = () => {
  if (isOnboarding) return;
  const hasRecaptchaScript = document.getElementById('recaptcha-script-paas');
  const hasNewRecaptchaScript = document.getElementById('new-recaptcha-script-paas');

  if (!hasRecaptchaScript && !hasNewRecaptchaScript) {
    const script = document.createElement('script');
    script.id = 'recaptcha-script-paas';
    script.src = RECAPTCHA_V3_URL(config.RECAPTCHA_PAAS);
    document.body.appendChild(script);
  }
  if (!hasNewRecaptchaScript) {
    const script = document.createElement('script');
    script.id = 'new-recaptcha-script-paas';
    script.src = RECAPTCHA_V3_URL(config.NEW_RECAPTCHA_PAAS);
    document.body.appendChild(script);

    if (hasRecaptchaScript) {
      const element = document.getElementById('recaptcha-script-paas');
      element.remove();
    }
  }
};
